module.exports = __webpack_public_path__ + "assets/img/img-map-fukuoka.97182deb.svg";